export default {
  downtimeUrl: "https://pl3.kodland.tech",
  startPage: {
    image: "/welcome/quiz_poland_yakub_video_pk.png",
    imageMobile: "/welcome/quiz_poland_yakub_video_mobile.png",
    title: "Zmień obsesję swojego dziecka na punkcie gier w okazję do rozpoczęcia udanej kariery programisty już teraz!",
    subtitle:
      "Podczas tych zajęć dziecko stworzy swoją pierwszą grę, program lub animację. Kliknij przycisk, aby zarezerwować miejsce na lekcji!",
    button: "Zaczynajmy",
  },
  successPage: {
    title: "Wybierz datę i godzinę, aby otrzymać lekcję ZA DARMO",
    subtitle: "Kliknij przycisk “📆 Zarezerwować lekcję“, aby dokończyć rejestrację",
    button: "📆 Zarezerwować lekcję",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Dziękujemy za zaufanie do naszej platformy edukacyjnej! Niestety, tablety czy telefony nie nadają się na lekcje. Czekamy na Państwo na zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Co według Ciebie są główne cele lekcji programowania w Kodland?",
      answers: [
        "🤖 Nauczyć dziecko programowania w Minecraft", 
        "🖥 Pomóc dziecku zrozumieć podstawy programowania",  
        "📈 Przygotować dziecko do kariery programisty", 
        "❓ Inne",  
      ],
    },
    2: {
      question: "Jakie korzyści z nauki programowania dla dzieci są dla Ciebie najważniejsze?",
      answers: [
        "💭 Rozwija kreatywność i umiejętności logicznego myślenia",
        "🎓 Poprawia wyniki w szkole",
        "🤖 Uczy programowania robotów",
        "❓Inne",
      ],
    },
    3: {
      question: "Czy Twoje dziecko posiada jakieś umiejętności komputerowe??",
      answers: [
        "👍 Tak, lubi grać w gry komputerowe (roblox, minecraft)", 
        "👏 Tak, word/power point",
        "🤝 Tak, podstawowe umiejętności",   
        "🤔 Nie",
      ],
    },
    4: {
      question: "Czy masz komputer/laptop służący do nauki?",
      answers: [
        "👍 Tak",
        {
          answer: "😕 Nie",
          stopAnswer: true
        },
      ],
    },
  },
};

